import React from 'react';
import { motion } from 'framer-motion';
export function OfferSection() {
  return <section id="offer-section" className="w-full bg-white" data-id="element-139">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24" data-id="element-140">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white border-4 border-[#C9A84C] rounded-2xl p-8 sm:p-12 shadow-2xl" data-id="element-141">
          <div className="text-center" data-id="element-142">
            <div className="inline-block bg-[#C9A84C] text-[#1B2A4A] px-6 py-2 rounded-full text-sm font-bold mb-6" data-id="element-143">
              PAGO ÚNICO
            </div>

            <h2 className="text-3xl sm:text-4xl font-bold text-[#1B2A4A] mb-4" data-id="element-144">
              Bundle Completo "Ciudadanía USA: Guía Exprés 2026"
            </h2>

            <div className="my-8" data-id="element-145">
              <div className="text-6xl sm:text-7xl font-bold text-[#1B2A4A]" data-id="element-146">
                $19
                <span className="text-3xl text-gray-600" data-id="element-147"> USD</span>
              </div>
            </div>

            <p className="text-lg text-gray-700 mb-8 max-w-2xl mx-auto" data-id="element-148">
              Es una inversión mínima comparada con el costo de tener que
              reaplicar o el valor de tu paz mental.
            </p>

            <motion.a href="https://dailyhomewellness.com/cart/48013338214644:1" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="inline-block bg-[#C9A84C] text-[#1B2A4A] px-10 py-5 rounded-lg font-bold text-xl hover:bg-[#d4b35c] transition-colors w-full sm:w-auto shadow-lg text-center" data-id="element-149">
              👉 DESCARGAR MI GUÍA AHORA
            </motion.a>

            <p className="text-sm text-gray-600 mt-6" data-id="element-150">
              Acceso inmediato tras el pago. Tu futuro como ciudadano comienza
              hoy.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}